import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          Invoice Automator
        </Link>
        
        <div className="navbar-menu">
          <Link to="/" className="navbar-link">Dashboard</Link>
          <Link to="/invoices" className="navbar-link">Facturas</Link>
          {(user.role === 'supervisor' || user.role === 'administrador') && (
            <Link to="/approval" className="navbar-link">Aprobaciones</Link>
          )}
          {user.canManageMasterData && (
            <Link to="/masterdata-management" className="navbar-link">Master Data</Link>
          )}
          {user.role === 'administrador' && (
            <Link to="/users-management" className="navbar-link">Gestión de Usuarios</Link>
          )}
          {user.role === 'administrador' && (
            <Link to="/afip-certificates" className="navbar-link">Certificados AFIP</Link>
          )}
        </div>
        
        <div className="navbar-user">
          <span className="user-name">{user.name}</span>
          <span className={`user-role badge badge-${
            user.role === 'administrador' ? 'approved' :
            user.role === 'supervisor' ? 'pending' : 'draft'
          }`}>
            {user.role === 'administrador' ? 'Administrador' : 
             user.role === 'supervisor' ? 'Supervisor' : 
             user.role === 'procesador' ? 'Procesador' : user.role}
          </span>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Cerrar Sesión
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
